import styled, { keyframes } from "styled-components"
import Icon from "../Icon"

// Shown while App checks the session before drawing the dashboard (VLT-3185): the login page's charger
// face, blinking, inside a charging pulse.

const appear = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
`

const pulse = keyframes`
  from { transform: scale(1); opacity: 0.5; }
  to { transform: scale(2); opacity: 0; }
`

const blink = keyframes`
  0%, 92%, 100% { transform: scaleY(1); }
  96% { transform: scaleY(0.2); }
`

const Container = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

// Held back a moment, so a session check that answers quickly never flashes the loader either.
const Face = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
  opacity: 0;
  animation: ${appear} 0.35s ease-out 0.25s forwards;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 0.01s;
  }
`

const Ring = styled.div<{ $delay: string }>`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid ${props => props.theme.colors.primary};
  opacity: 0;
  animation: ${pulse} 1.8s cubic-bezier(0.2, 0.6, 0.4, 1) ${props => props.$delay} infinite;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`

const Layer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
`

// The ring keeps the dark face visible on the dark theme's near-black background.
const FaceLayer = styled(Layer)`
  border-radius: 50%;
  box-shadow: 0 0 0 1.5px ${props => props.theme.colors.gray_300};
`

const Eyes = styled(Layer)`
  transform-origin: 50% 41%;
  animation: ${blink} 3.2s ease-in-out 0.6s infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export default function StartupLoader() {
  return (
    <Container aria-busy="true">
      <Face>
        <Ring $delay="0s" />
        <Ring $delay="0.9s" />
        <FaceLayer><Icon path="login.chargerFace" color="#141518" width="100%" height="100%" /></FaceLayer>
        <Eyes><Icon path="login.chargerEye" width="100%" height="100%" /></Eyes>
      </Face>
    </Container>
  )
}
